module.exports = __webpack_public_path__ + "static/media/Template_42.5c141149.png";